 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import BACKEDBIRDSFRONT_1 from '@/components/Backed/birdsfront_1'
 import BACKEDTLU_1 from '@/components/Backed/tlu_1'
 import BACKEDPORTALISTAD_1 from '@/components/Backed/portalistad_1'
 import BACKEDMM from '@/components/Backed/MM'
 import LOVE_1 from '@/components/love_1'
 import SECTION0001 from '@/components/section0001'
 import SECTION0006 from '@/components/section0006'
 import SECTION0007 from '@/components/section0007'
 import SECTION0008TITLE from '@/components/section0008title'
 import SECTION0008 from '@/components/section0008'
 import SECTION0009TITLE from '@/components/section0009title'
 import SECTION0009 from '@/components/section0009'
 import SECTION0010TITLE from '@/components/section0010title'
 import SECTION0010 from '@/components/section0010'
 import SECTION00101 from '@/components/section00101'
 import SECTION00102 from '@/components/section00102'
 import SECTION00103 from '@/components/section00103'
 import SECTION00104 from '@/components/section00104'
 import SECTION00105 from '@/components/section00105'
 import SECTION00106 from '@/components/section00106'
 import SECTION00107 from '@/components/section00107'
 import SECTION00108 from '@/components/section00108'
 import SECTION00109 from '@/components/section00109'
 import SECTION001010 from '@/components/section001010'
 import SECTION001011 from '@/components/section001011'
 import SECTION001012 from '@/components/section001012'
 import SECTION0011TITLE from '@/components/section0011title'
 import SECTION0011 from '@/components/section0011'
 import SECTION00111 from '@/components/section00111'
 import SECTION00112 from '@/components/section00112'
 import SECTION00113 from '@/components/section00113'
 import SECTION00114 from '@/components/section00114'
 import SECTION0012TITLE from '@/components/section0012title'
 import SECTION0012 from '@/components/section0012'
 import LOVE_2 from '@/components/love_2'
 import ABA from '@/components/aba'
 import BACKEDBACKAD_1 from '@/components/Backed/backad_1'
 import BACKEDORIMAD_1 from '@/components/Backed/ORIMad_1'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/Backed/birdsfront_1",
 			"name" : "Backed/birdsfront_1",
 			"component" : BACKEDBIRDSFRONT_1
 		},
 		{
 			"path" : "/Backed/tlu_1",
 			"name" : "Backed/tlu_1",
 			"component" : BACKEDTLU_1
 		},
 		{
 			"path" : "/Backed/portalistad_1",
 			"name" : "Backed/portalistad_1",
 			"component" : BACKEDPORTALISTAD_1
 		},
 		{
 			"path" : "/Backed/MM",
 			"name" : "Backed/MM",
 			"component" : BACKEDMM
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/section0001",
 			"name" : "section0001",
 			"component" : SECTION0001
 		},
 		{
 			"path" : "/section0006",
 			"name" : "section0006",
 			"component" : SECTION0006
 		},
 		{
 			"path" : "/section0007",
 			"name" : "section0007",
 			"component" : SECTION0007
 		},
 		{
 			"path" : "/section0008title",
 			"name" : "section0008title",
 			"component" : SECTION0008TITLE
 		},
 		{
 			"path" : "/section0008",
 			"name" : "section0008",
 			"component" : SECTION0008
 		},
 		{
 			"path" : "/section0009title",
 			"name" : "section0009title",
 			"component" : SECTION0009TITLE
 		},
 		{
 			"path" : "/section0009",
 			"name" : "section0009",
 			"component" : SECTION0009
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js